import { default as _91id_939IzwuvryJLMeta } from "/var/www/html/collection-experience/frontend-2/pages/[locale]/[id].vue?macro=true";
import { default as cookie_45policyo4GNUZgKwKMeta } from "/var/www/html/collection-experience/frontend-2/pages/[locale]/cookie-policy.vue?macro=true";
import { default as indexF1bai8HSlEMeta } from "/var/www/html/collection-experience/frontend-2/pages/[locale]/index.vue?macro=true";
import { default as privacy_45policyny8rBexvpzMeta } from "/var/www/html/collection-experience/frontend-2/pages/[locale]/privacy-policy.vue?macro=true";
export default [
  {
    name: "locale-id",
    path: "/:locale()/:id()",
    component: () => import("/var/www/html/collection-experience/frontend-2/pages/[locale]/[id].vue")
  },
  {
    name: "locale-cookie-policy",
    path: "/:locale()/cookie-policy",
    component: () => import("/var/www/html/collection-experience/frontend-2/pages/[locale]/cookie-policy.vue")
  },
  {
    name: "locale",
    path: "/:locale()",
    component: () => import("/var/www/html/collection-experience/frontend-2/pages/[locale]/index.vue")
  },
  {
    name: "locale-privacy-policy",
    path: "/:locale()/privacy-policy",
    component: () => import("/var/www/html/collection-experience/frontend-2/pages/[locale]/privacy-policy.vue")
  }
]